/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} None_OptionInputs */

const en_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const fr_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun`)
};

const de_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

const it_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno`)
};

const ru_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никто`)
};

const es_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno`)
};

const zh_cn2_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何`)
};

const ja_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

const hi_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई नहीं`)
};

const pt_pt2_none_option = /** @type {(inputs: None_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {None_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const none_option = /** @type {((inputs?: None_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<None_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_none_option(inputs)
	if (locale === "de") return de_none_option(inputs)
	if (locale === "it") return it_none_option(inputs)
	if (locale === "ru") return ru_none_option(inputs)
	if (locale === "es") return es_none_option(inputs)
	if (locale === "zh-CN") return zh_cn2_none_option(inputs)
	if (locale === "ja") return ja_none_option(inputs)
	if (locale === "hi") return hi_none_option(inputs)
	if (locale === "pt-PT") return pt_pt2_none_option(inputs)
	return en_none_option(inputs)
});